import { Component, OnDestroy, OnInit, OnChanges, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { FormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { takeUntil, tap, switchMap } from 'rxjs/operators';

import { ActivatedRoute, Router } from '@angular/router';
import { CreditService } from '../../services/credit.service';
import { GlobalsService } from '../../services/globals.service';
import { CustomerService } from '../../services/customer.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

import { Directive, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as FileSaver from 'file-saver';
import { Location } from '@angular/common'

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from 'app/services/users.service';
import { OmsService } from 'app/services/oms.service';
import { Tpl3plService } from '../../services/tpl3pl.service';

@Component({
	selector: 'app-open-credits',
	templateUrl: './open-credits.component.html',
	styleUrls: ['./open-credits.component.scss']
})

export class OpenCreditsComponent implements OnInit, OnChanges, OnDestroy {

	@Input() customerdata: any = [];
	@Input() item: any = false;
	@Input() lookingfor: any = false;
	@Output() cart_updated = new EventEmitter < string > ();
	@Output() orderloaded = new EventEmitter < any > ();
	@Output() cancel = new EventEmitter < boolean > ();
	@Output() credit_data = new EventEmitter < any > ();


	searchInput = new UntypedFormControl('');
	searchInputItems = new UntypedFormControl('');
	defaultlocation = new UntypedFormControl('');
	order_status_edit = new UntypedFormControl('');
	order_statuses: any = false;
	openorders: any = [];
	customertrans: any = [];
	filteredItems: any = [];
	private readonly baseHeaderColumns: string[] = [
		'orderno',
		'statusname',
		'deliverydate',
		'from_order',
		'customer',
		'deliverto',
		'ponumber',
		'phoneno',
		'email',
		'totals'
	];
	headercolumns: string[] = [...this.baseHeaderColumns];

	// PGS 360 RMA pickup — only active when 3PL is enabled and PGS-type
	tpl3plPgsEnabled = false;
	pgsSendingOrderNo: string | null = null;
	pgsResultByOrder: { [orderno: string]: { success: boolean; message?: string; cached?: boolean } } = {};
	selectedPgsReceipt: any = null;

	orderupdates: any = [];
	openOrderData: any = [];
	allopenOrderData: any = [];
	config: any = [];
	pickinglink = '';
	orderdetails: any = [];
	locations: any = [];

	itemsearchresults: any = [];
	itemsearch = false;
	user: any = false;
	ref_location: any = false;
	returnSheetLink: any = '';
	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;

	orderMatches: any = [];

	color = 'blue';
	showFilters = false;
	loading = false;

	private static readonly THEME_PALETTE: Record<string, { light: [number, number, number]; base: [number, number, number]; dark: [number, number, number] }> = {
		purple:  { light: [206, 147, 216], base: [156,  39, 176], dark: [ 74,  20, 140] },
		primary: { light: [206, 147, 216], base: [156,  39, 176], dark: [ 74,  20, 140] },
		blue:    { light: [144, 202, 249], base: [ 33, 150, 243], dark: [ 25, 118, 210] },
		info:    { light: [128, 222, 234], base: [  0, 188, 212], dark: [  0,  96, 100] },
		green:   { light: [165, 214, 167], base: [ 76, 175,  80], dark: [ 27,  94,  32] },
		success: { light: [165, 214, 167], base: [ 76, 175,  80], dark: [ 27,  94,  32] },
		orange:  { light: [255, 204, 128], base: [255, 152,   0], dark: [230,  81,   0] },
		warning: { light: [255, 224, 130], base: [255, 193,   7], dark: [255, 143,   0] },
		red:     { light: [239, 154, 154], base: [244,  67,  54], dark: [183,  28,  28] },
		danger:  { light: [239, 154, 154], base: [244,  67,  54], dark: [183,  28,  28] },
		rose:    { light: [244, 143, 177], base: [233,  30,  99], dark: [136,  14,  79] },
	};

	get palette() {
		return OpenCreditsComponent.THEME_PALETTE[this.color] || OpenCreditsComponent.THEME_PALETTE['blue'];
	}

	get themeVars(): { [key: string]: string } {
		const p = this.palette;
		const rgb  = (c: number[]) => `rgb(${c[0]},${c[1]},${c[2]})`;
		const rgba = (c: number[], a: number) => `rgba(${c[0]},${c[1]},${c[2]},${a})`;
		return {
			'--oc-accent':        rgb(p.base),
			'--oc-accent-dark':   rgb(p.dark),
			'--oc-accent-light':  rgb(p.light),
			'--oc-accent-tint':   rgba(p.base, 0.07),
			'--oc-accent-tint-2': rgba(p.base, 0.14),
			'--oc-accent-border': rgba(p.base, 0.20),
			'--oc-accent-bg':     rgba(p.light, 0.16),
		};
	}

	private readonly destroy$ = new Subject<void>();
	private dataLoadSub: Subscription | null = null;

	constructor(private omsService:OmsService,  private usersService:UsersService, public creditService: CreditService, public globalSearchService: GlobalSearchService, public router: Router, public customerService: CustomerService, private location: Location, private globalsService: GlobalsService, private modalService: NgbModal, private tpl3plService: Tpl3plService) {
		this.config = this.globalsService.getApiConfig();

		this.pickinglink = this.config.apiServer.baseUrl + this.config.apiServer.creditPickingLink;
		this.returnSheetLink = this.config.apiServer.baseUrl + this.config.apiServer.returnSheetLink;
	}

	ngOnInit(): void {
		this.initPgsColumn();

		this.globalSearchService.locations
			.pipe(takeUntil(this.destroy$))
			.subscribe((results: any) => {
				this.locations = results;
				if (results?.length) {
					this.defaultlocation.setValue(results[0].loccode);
				}
			});

		this.creditService
			.getOrderStatuses()
			.pipe(
				tap((r: any) => {
					this.order_statuses = r;
				}),
				switchMap(() => this.globalSearchService.user),
				takeUntil(this.destroy$)
			)
			.subscribe((results) => {
				if (this.user) {
					if (results.user.defaultlocation.loccode != this.ref_location) {
						this.defaultlocation.setValue(this.user.user.defaultlocation.loccode);
						this.loadData();
						this.ref_location = false;
					}
				}

				this.user = results;
				if (!this.ref_location) {
					this.ref_location = this.user.user.defaultlocation.loccode;
				}
			});
	}

	ngOnDestroy(): void {
		this.dataLoadSub?.unsubscribe();
		this.dataLoadSub = null;
		this.destroy$.next();
		this.destroy$.complete();
	}

	openModal(content) {
		this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
	}

	openPgsReceipt(tran: any, content: any): void {
		this.selectedPgsReceipt = tran;
		this.modalService.open(content, { ariaLabelledBy: 'pgs-receipt-title', size: 'xl' })
			.result.finally(() => this.selectedPgsReceipt = null);
	}

	search() {
		this.itemsearch = false;
		const value = this.searchInput.value;
		if (value && value != '') {
			this.openorders = this.globalSearchService.filterItem(this.openOrderData, value, 'orderno,transno,ponumber,debtorno,deliverto,deliverydate,stockid,description');

			this.openorders = new MatTableDataSource(this.openorders);
			this.openorders.sort = this.sort;
			this.openorders.paginator = this.paginator;

		} else {
			this.openOrderData = this.allopenOrderData
			this.openorders = new MatTableDataSource(this.allopenOrderData);
			this.openorders.sort = this.sort;
			this.openorders.paginator = this.paginator;
		}
	}

	getTotal(totals: any) {
		if(totals) {
			const total= totals.filter( r => {
				if(r.code) {
					return r.code == 'total'
				}
			})[0];
			if(total) {
				return total.text
			}
		}

		return 0.00;

	}

	/** Numeric value of a single credit row (totals come back as text). */
	creditValue(tran: any): number {
		const raw = this.getTotal(tran?.totals);
		const num = parseFloat(String(raw).replace(/[^0-9.\-]/g, ''));
		return isNaN(num) ? 0 : num;
	}

	get statCount(): number {
		return Array.isArray(this.allopenOrderData) ? this.allopenOrderData.length : 0;
	}

	get statTotal(): number {
		if (!Array.isArray(this.allopenOrderData)) { return 0; }
		return this.allopenOrderData.reduce((sum: number, t: any) => sum + this.creditValue(t), 0);
	}

	get statLargest(): number {
		if (!Array.isArray(this.allopenOrderData) || !this.allopenOrderData.length) { return 0; }
		return this.allopenOrderData.reduce((max: number, t: any) => Math.max(max, this.creditValue(t)), 0);
	}

	searchItems() {
		const value = this.searchInputItems.value;

		if (value && value != '') {
			this.itemsearch = true;
			const searchdata = [];
			this.openOrderData.forEach((item: any) => {
				searchdata.push(item.details)
			});

			const searchresults = this.globalSearchService.filterItem(searchdata, value, 'orderno,narrative,stkcode,description,ordervalue');
			const mapped = searchresults.map(i => i.orderno);

			this.itemsearchresults = searchresults;

			this.openorders = this.openOrderData.filter(o => {
				return mapped.includes(o.orderno);
			});

			this.openorders = new MatTableDataSource(this.openorders);
			this.openorders.sort = this.sort;
			this.openorders.paginator = this.paginator;

		} else {
			this.openOrderData = this.allopenOrderData
			this.openorders = new MatTableDataSource(this.allopenOrderData);
			this.openorders.sort = this.sort;
			this.openorders.paginator = this.paginator;
		}

	}

	onInput(event: any) {
		if (this.openOrderData) {
			this.openorders = this.globalSearchService.filterItem(this.openOrderData, event, 'orderno,transno,ponumber,debtorno,deliverto,deliverydate');
		}
	}

	viewOrder(orderno: any, content: any) {

		this.creditService.getOrder(orderno).subscribe((order: any) => {
			this.orderdetails = order
			this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
		});
	}

	loadOrder(tran: any) {
		// Every row here is an OPEN RMA (creditorders, completed=0), so load it by its
		// RMA orderno — credits/loadorder pulls the actual creditorder lines for editing.
		// The old invoiceid path went via debtortrans and blanked (no row yet) or loaded
		// the wrong lines (invoiceid is a false-positive for freestanding RMAs where
		// from_order=0 matches a stray order_=0 credit note).
		this.router.navigate(['/receivables/credit-rma/' + tran.orderno]);
		this.cart_updated.emit(tran.orderno);
	}

	loadData() {
		this.dataLoadSub?.unsubscribe();
		this.dataLoadSub = null;

		let search = '';
		let load$: any = null;

		if (this.customerdata && this.customerdata.debtorno) {
			if (this.customerdata.debtorno) {
				search = this.customerdata.debtorno;
			}
			if (this.customerdata && search === '') {
				search = this.customerdata.customer.debtorno;
			}
			load$ = this.creditService.getCustomerOpenOrders(search);
		} else if (this.item) {
			search = this.item;
			load$ = this.creditService.getCustomerOpenOrdersByItem(search);
		} else if (!this.item && !this.customerdata) {
			load$ = this.creditService.getCustomerOpenOrders([]);
		}

		if (!load$) {
			return;
		}

		this.loading = true;
		this.dataLoadSub = load$
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: (results: any) => {
					this.loading = false;
					this.openOrderData = results;
					this.allopenOrderData = results;
					if (results) {
						this.credit_data.emit(results);
						// Re-apply whatever item search was active instead of overwriting it with
						// the raw dataset — every action here (Send to PGS, cancel, set delivered,
						// pick) reloads via loadData(), and used to silently drop the filter.
						this.searchItems();
					}
				},
				error: () => {
					this.loading = false;
				}
			});
	}

	cancelOrder(orderno: any, force: boolean = false) {
		this.creditService.cancelOrder(orderno, force).subscribe(async (results: any) => {
			// PGS still had the inbound open and refused to drop it (it locks a return
			// as soon as receiving posts against it). Nothing was cancelled here — the
			// goods are on their way back, so finalizing is usually the right move.
			if (results && results.success === false && results.pgs_blocked) {
				const proceed = confirm('PGS would not cancel this return: ' + (results.message || 'rejected')
					+ '\n\nCancel it in QBC anyway? PGS will still receive the goods.');
				if (proceed) {
					this.cancelOrder(orderno, true);
				}
				return;
			}
			if (results && results.success === false) {
				this.globalSearchService.showNotification('RMA #' + orderno + ' not cancelled: '
					+ (results.message || 'unknown error'), 'danger', 'bottom', 'right');
				return;
			}
			if (results && results.pgs && !results.pgs.skipped && results.pgs.message) {
				this.globalSearchService.showNotification(results.pgs.message, 'success', 'bottom', 'right');
			}
			this.cancel.emit(true);
			this.cart_updated.emit(results);
			this.credit_data.emit(results);
			this.loadData()
		})
	}

	setDelivered(orderno: any) {
		this.creditService.setDelivered({ orderno: orderno }).subscribe(async (results: any) => {
			this.loadData()
		})
	}

	updatePick(orderno: any) {
		//needs callback to have customer only
		this.creditService.updateOrderToPicked({ orderno: orderno }).subscribe(async (results: any) => {
			this.loadData()
		})
	}

	/** Notify PGS 360 to schedule a pickup from this customer for their RMA. */
	sendRmaToPgs(orderno: string, forceResend = false): void {
		if (!this.tpl3plPgsEnabled || this.pgsSendingOrderNo) { return; }
		this.pgsSendingOrderNo = orderno;
		this.creditService.sendRmaToPgs(orderno, forceResend).pipe(takeUntil(this.destroy$)).subscribe({
			next: (result: any) => {
				this.pgsSendingOrderNo = null;
				this.pgsResultByOrder[orderno] = result;
				this.loadData();
			},
			error: (err: any) => {
				this.pgsSendingOrderNo = null;
				this.pgsResultByOrder[orderno] = { success: false, message: err?.error?.message || 'Request failed' };
			}
		});
	}

	back(): void {
		this.location.back()
	}

	/** Total units PGS has confirmed received for this RMA (0 if none yet). */
	receivedTotalQty(tran: any): number {
		const lines = tran?.tpl3pl_received?.lines || [];
		return lines.reduce((sum: number, l: any) => sum + (Number(l.qty_received) || 0), 0);
	}

	/** Multi-line summary of confirmed received quantities, for the row tooltip. */
	receivedTooltip(tran: any): string {
		const rec = tran?.tpl3pl_received;
		if (!rec || !rec.lines?.length) { return ''; }
		const head = `Received ${this.receivedTotalQty(tran)} units`
			+ (rec.receipt_no ? ` · receipt ${rec.receipt_no}` : '')
			+ (rec.receipt_date ? ` · ${rec.receipt_date}` : '')
			+ (rec.needs_review ? '  ⚠ NEEDS REVIEW' : '');
		const lines = rec.lines.map((l: any) =>
			`${l.itemcode} ×${l.qty_received}` + (l.orderlineno ? '' : ' (not on order!)')
		).join('\n');
		const followup = rec.followup
			? `\nLeftover follow-up pickup sent: ${rec.followup.purchase_order_no}` + (rec.followup.success ? '' : ' (send failed — will retry)')
			: '';
		return head + '\n' + lines + followup;
	}

	statusLabel(tran: any): string {
		if (tran?.tpl3pl_received?.pending_qty > 0) { return 'Partially Received'; }
		if (tran?.statusname) { return tran.statusname; }
		if (tran?.tpl3pl_received?.needs_review) { return 'Return Review'; }
		if (tran?.tpl3pl_received) { return 'Return Received'; }
		return 'Open';
	}

	statusBadgeStyle(tran: any): { [key: string]: string } | null {
		if (Number(tran?.tpl3pl_received?.pending_qty) > 0) {
			return { 'background-color': '#ef6c00', color: '#ffffff' };
		}
		const background = String(tran?.status_badge_bg || '').trim();
		const color = String(tran?.status_badge_fg || '').trim();
		if (!background && !color) { return null; }
		return {
			...(background ? { 'background-color': background } : {}),
			...(color ? { color } : {}),
		};
	}

	hasReceiptProgress(receipt: any): boolean {
		return receipt?.ordered_qty != null
			&& receipt?.received_qty != null
			&& receipt?.credited_qty != null
			&& receipt?.pending_qty != null;
	}

	receiptAlertClass(receipt: any): string {
		if (!this.hasReceiptProgress(receipt) || receipt?.needs_review || Number(receipt?.pending_qty) > 0) {
			return 'alert-warning';
		}
		return 'alert-success';
	}

	receiptHeadline(receipt: any): string {
		if (!this.hasReceiptProgress(receipt)) {
			return 'Receipt comparison unavailable — the server response is incomplete.';
		}
		if (receipt.needs_review) {
			return 'Received with exceptions — review before crediting.';
		}
		if (Number(receipt.pending_qty) > 0) {
			const uncredited = Number(receipt.received_uncredited_qty) || 0;
			return uncredited > 0
				? `Partially received — ${uncredited} received units are ready to credit; ${receipt.pending_qty} remain pending from PGS.`
				: `Partially received — ${receipt.pending_qty} units remain pending from PGS.`;
		}
		if (Number(receipt.received_uncredited_qty) > 0) {
			return 'Fully received and ready to credit.';
		}
		return 'Fully received and credited.';
	}

	private initPgsColumn(): void {
		if (this.config?.env?.client !== 'km') {
			this.tpl3plPgsEnabled = false;
			this.headercolumns = [...this.baseHeaderColumns];
			return;
		}
		this.tpl3plService.getConfig().pipe(takeUntil(this.destroy$)).subscribe({
			next: (cfg: any) => {
				this.tpl3plPgsEnabled = !!(cfg?.enabled && cfg?.integration_type === 'PGS');
				this.headercolumns = this.tpl3plPgsEnabled
					? [...this.baseHeaderColumns, 'pgs360_rma']
					: [...this.baseHeaderColumns];
			},
			error: () => {
				this.tpl3plPgsEnabled = false;
				this.headercolumns = [...this.baseHeaderColumns];
			}
		});
	}

	ngOnChanges(changes: any): void {
		if (changes.customerdata || changes.item) {
			this.loadData();
		}

		if(changes.lookingfor){
			if(changes.lookingfor.currentValue.length){
				this.orderMatches = changes.lookingfor.currentValue.map((ord) => {
					return ord['orderno'];
				})
			}else{
				this.orderMatches = [];
			}

		}
	}

	toggleEdit(tran: any) {
		if (!tran.edit) {
			tran.edit = true;
			this.order_status_edit.setValue(tran.orderstatusid);
		} else {
			tran.edit = false;
		}
	}
	exportToXLS() {

	}

	exportToPDF() {

	}
	saveStatusUpdate(tran: any) {

		const data = {
			trans: tran,
			type: this.order_status_edit.value,
			user: this.user,
		}

		this.creditService.updateOrderStatus(data).subscribe((r: any) => {
			if (r.success) {
				tran.edit = false;
				const status = this.order_statuses.filter(s => {
					return s.order_status_id == data.type;
				})[0];
				tran.statusname = status.name;
				tran.details.orderstatusid = data.type;
				this.order_status_edit.reset();

				this.loadData();

			}
		})
	}

	announceSortChange(sortState: Sort) {

	}

	usePrintConnect(){
		const ep = this.usersService.usePrintConnect();
		return ep;
	}

	printCustomerCopy(orderid){
		
		this.creditService.printCustomerCredit(orderid).subscribe((res: any) => {
			const type = 'CREDIT';
			const user = this.user.user.userid;
			const printers = this.usersService.getDevicesByType(user, type);
			if (printers && printers.length && res.base64.length) {
				this.omsService.setNewOrder();
				const rma = res['base64'][0];
				const data = { pdf: rma, user: user, devices: printers }	
				this.omsService.sendPrintCommand({ data, roomName: 'Printers' }, cb => {
					this.omsService.setPrintedOrder();
				})
			}
		});
	}

}
